import { formatText } from 'core/i18n';
import {
    recordInitialPage,
    recordEvent,
    recordError,
    PAGE_INITIAL,
    errorTag,
    recordEventCustomOnly,
} from 'utilities/uTagging';
import { ERROR_AL_TRAER_LOS_PRODUCTOS } from 'constants/analyticsErrors';
import { PATH_MINOR, PATH_OPEN_YOUR_ACCOUNT } from 'constants/uTagConstants/paths';
import { EVENT_DETAIL_RECOVER_HERE, EVENT_ONBOARDING } from 'constants/uTagConstants/RAConstants';
import cryptoJS from 'crypto-js';

export const doTagInvalidProduct = error =>
    errorTag(error.body, PATH_OPEN_YOUR_ACCOUNT, ERROR_AL_TRAER_LOS_PRODUCTOS, error.statusCode);
export const doTagErrorRequiredFields = (userProfile, fieldsWithError) =>
    recordError(
        `[${fieldsWithError}]:campos requeridos para continuar.`,
        userProfile.investmentType ? userProfile.investmentType : ''
    );
export const doTagErrorIncorrectRegister = (userProfile, docNumberEncrypted) =>
    recordEvent(
        PATH_OPEN_YOUR_ACCOUNT,
        PAGE_INITIAL,
        'registro',
        'registro incorrecto',
        '',
        '',
        '',
        userProfile.investmentType ? userProfile.investmentType : '',
        docNumberEncrypted
    );
export const doTagCreditCardOfferAccepted = (userProfile, docNumberEncrypted) =>
    recordEvent(
        PATH_OPEN_YOUR_ACCOUNT,
        PAGE_INITIAL,
        'tarjeta de credito checkbox',
        'tarjeta de credito checkbox checkeado',
        '',
        '',
        '',
        userProfile.investmentType,
        docNumberEncrypted
    );
export const doTagCreditCardOfferNotAccepted = (userProfile, docNumberEncrypted) =>
    recordEvent(
        PATH_OPEN_YOUR_ACCOUNT,
        PAGE_INITIAL,
        'tarjeta de credito checkbox',
        'tarjeta de credito checkbox no checkeado',
        '',
        '',
        '',
        userProfile.investmentType,
        docNumberEncrypted
    );
export const doTagRegisterSuccess = (userProfile, docNumberEncrypted) =>
    recordEvent(
        PATH_OPEN_YOUR_ACCOUNT,
        PAGE_INITIAL,
        'registro',
        'registro correcto',
        '',
        '',
        '',
        userProfile.investmentType ? userProfile.investmentType : '',
        docNumberEncrypted,
        {},
        {
            event_name: 'event_success',
            action: 'success',
            format: 'steps',
            component: 'funnel',
            element: 'register',
        }
    );
export const doTagRegisterSuccessButtonClick = (userProfile, docNumberEncrypted) =>
    recordEvent(
        PATH_OPEN_YOUR_ACCOUNT,
        PAGE_INITIAL,
        '',
        '',
        '',
        '',
        '',
        userProfile.investmentType ? userProfile.investmentType : '',
        docNumberEncrypted,
        {},
        {
            event_name: 'button_click',
            action: 'click',
            format: 'button',
            component: 'form',
            element: 'start',
        }
    );
export const doTagNotResident = (userProfile, docNumberEncrypted) =>
    recordEvent(
        PATH_OPEN_YOUR_ACCOUNT,
        PAGE_INITIAL,
        'no residente envio de email',
        'no residente envio de email correcto',
        '',
        '',
        '',
        userProfile.investmentType ? userProfile.investmentType : '',
        docNumberEncrypted
    );
export const doTagValidateBirthday = (userProfile, products) =>
    recordInitialPage(
        PATH_MINOR,
        userProfile.product,
        products.get('productsDescription'),
        userProfile.investmentType ? userProfile.investmentType : '',
        userProfile.docNumber ? cryptoJS.SHA256(userProfile.docNumber).toString() : ''
    );
export const doTagInvalidBirthday = userProfile =>
    recordError(
        `birthDate:${formatText('validation-birthDate')}`,
        userProfile.investmentType ? userProfile.investmentType : ''
    );
export const doTagValidationFieldRequired = userProfile =>
    recordError(
        `birthDate:${formatText('validation-fieldRequired')}`,
        userProfile.investmentType ? userProfile.investmentType : ''
    );
export const doTagSendRecoverTag = () => {
    recordEvent(
        PATH_OPEN_YOUR_ACCOUNT,
        EVENT_ONBOARDING,
        PATH_OPEN_YOUR_ACCOUNT,
        EVENT_DETAIL_RECOVER_HERE,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        {
            action: 'click',
            format: 'link',
            component: 'form',
            element: 'recoverProcess',
            eventCategory: 'onboarding/step1/personalData',
            eventAction: 'clickLink',
            eventLabel: 'recoverProcess',
        }
    );
};

export const doTagButtonUnderstood = () => {
    recordEventCustomOnly({
        action: 'click',
        format: 'button',
        component: 'form',
        element: 'understood',
        eventCategory: 'onboarding/step1/personalData',
        eventAction: 'clickButton',
        eventLabel: 'understoodButton',
    });
};
